import { useAuth } from '@contexts/AuthContext';
import { ThemeProvider } from '@material-ui/core';
import { BaseMuiTheme, Loader } from '@swyft/core';
import React, { useEffect } from 'react';

interface Props {
  name: string;
  redirectPath: string;
}

export const SignedOutPage: React.FC<Props> = ({ name, redirectPath }) => {
  const { signInRedirect } = useAuth();

  useEffect(() => {
    signInRedirect(redirectPath);
  }, []);

  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <Loader />
    </ThemeProvider>
  );
};
